<template>
  <!-- begin #top-menu -->
  <div id="top-menu" :class="{ 'd-block': pageOptions.pageMobileTopMenu }" class="top-menu">
    <!-- begin top-menu nav -->
    <top-menu-nav/>
    <!-- end top-menu nav -->
  </div>
  <!-- end #top-menu -->
</template>

<script>
import TopMenuNav from './TopMenuNav.vue'
import PageOptions from '../../config/PageOptions.vue'

export default {
	name: 'TopMenu',
	components: {
		TopMenuNav
	},
	data() {
		return {
			pageOptions: PageOptions
		}
	}
}
</script>
